import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { socketService } from '@/services/socket';

export function useRealtimeUpdates(queryKeys: string[]) {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Connect socket on mount
    socketService.connect();

    // Create handlers for each query key
    const handlers = queryKeys.map(key => {
      const handler = () => {
        queryClient.invalidateQueries({ queryKey: [key] });
      };
      socketService.on(`${key}:change`, handler);
      return { key, handler };
    });

    // Cleanup
    return () => {
      handlers.forEach(({ key, handler }) => {
        socketService.off(`${key}:change`, handler);
      });
    };
  }, [queryClient, queryKeys.join(',')]);
}
